import moment from "moment";

export const validaData = data => moment(data, "DD/MM/YYYY").isValid();

export const formataDataPtBr = data => moment(data, "YYYY/MM/DD").format("DD/MM/YYYY");

export const formataDataEnUS = data => moment(data, "DD/MM/YYYY").format("YYYY/MM/DD");

export const rulesCommon = {
    required: v => !!v || 'Campo obrigatório',
    email: v => /.+@.+/.test(v) || 'E-mail inválido',
};




// WEBPACK FOOTER //
// ./src/helpers/validates.js